import React from 'react';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../assets/LockUnlock.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleInfo } from '@fortawesome/free-solid-svg-icons';

const LockDayToggle = ({ mealPlan, setMealPlan }) => {
    const handleToggleLock = () => {
        // Αλλάζουμε μόνο το lock property, χωρίς να πειράξουμε τα υπόλοιπα
        setMealPlan((prevState) => ({
            ...prevState,  // Κρατάμε όλα τα υπόλοιπα properties ίδια
            lock: !prevState.lock // Αναποδογυρίζουμε την τιμή του lock
        }));
    };
    const handleToggleHoliday = () => {
        // Αλλάζουμε μόνο το lock property, χωρίς να πειράξουμε τα υπόλοιπα
        setMealPlan((prevState) => ({
            ...prevState,  // Κρατάμε όλα τα υπόλοιπα properties ίδια
            holiday: !prevState.holiday // Αναποδογυρίζουμε την τιμή του lock
        }));
    };

    return (
        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', alignItems: 'center', width: '50%' }}>
                <h6 className='text-offcanvas'>
                    Κλείδωμα Ημέρας <OverlayTrigger placement="bottom" overlay={<Tooltip className="in" id="tooltip-top">
                        Η ημέρα κλειδώνει, το μενού εμφανίζεται κανονικά στους χρήστες, αλλά δεν επιτρέπονται παραγγελίες μέχρι να ξεκλειδωθεί.
                    </Tooltip>
                    }>
                        <FontAwesomeIcon icon={faCircleInfo} size="sm" color="gray" style={{ marginLeft: '5px' }} />
                    </OverlayTrigger>
                </h6>
                <Button
                    variant="light"
                    className={`custom-toggle-button ${mealPlan?.lock ? 'on' : 'off'}`}
                    onClick={handleToggleLock}
                >
                    <div className={`slider ${mealPlan?.lock ? 'slide-on' : 'slide-off'}`}></div>
                    <div className={`label-${mealPlan?.lock ? 'on' : 'off'}`}>
                        {mealPlan.lock ? 'Ναι' : 'Όχι'}
                    </div>
                </Button>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', alignItems: 'center', width: '50%', }}>
                <h6 className='text-offcanvas'>
                    Αργία <OverlayTrigger placement="bottom" overlay={<Tooltip className="in" id="tooltip-top">
                        Η ημέρα κλειδώνει λόγω αργίας και δεν υπάρχουν διαθέσιμα πιάτα για παραγγελία.
                    </Tooltip>
                    }>
                        <FontAwesomeIcon icon={faCircleInfo} size="sm" color="gray" style={{ marginLeft: '5px' }} />
                    </OverlayTrigger>
                </h6>
                <Button
                    variant="light"
                    className={`custom-toggle-button ${mealPlan.holiday ? 'on' : 'off'}`}
                    onClick={handleToggleHoliday}
                >
                    <div className={`slider ${mealPlan?.holiday ? 'slide-on' : 'slide-off'}`}></div>
                    <div className={`label-${mealPlan?.holiday ? 'on' : 'off'}`}>
                        {mealPlan?.holiday ? 'Ναι' : 'Όχι'}
                    </div>
                </Button>
            </div>
        </div>
    );
};

export default LockDayToggle;
